import nutritionIcon from './images/core-images/nutrition.svg';
import metabolismIcon from './images/core-images/metabolism.svg';
import exerciseIcon from './images/core-images/exercise.svg';
import stressIcon from './images/core-images/stress.svg';
import gutBalanceIcon from './images/core-images/gut-balance.svg';
import skinHealthIcon from './images/core-images/skin-health.svg';

export const SCORE_LEVELS = {
  BALANCE: { min: 60, label: 'สมดุล', colorClass: 'level-balance', color: '#72CC50' },
  FAIR: { min: 40, label: 'ค่อนข้างดี', colorClass: 'level-fair', color: '#FFC92B' },
  MODERATE: { min: 20, label: 'ปานกลาง', colorClass: 'level-moderate', color: '#FFA84E' },
  IMPROVE: { min: 0, label: 'ปรับปรุง', colorClass: 'level-improve', color: '#EE1811' },
  NO_DATA: { label: 'ไม่มีข้อมูล', colorClass: 'level-no-data', color: '#A1A1A1' },
};

export const getScoreLevel = (score) => {
  if (score === null || score === undefined) return SCORE_LEVELS.NO_DATA;
  if (score >= 60) return SCORE_LEVELS.BALANCE;
  if (score >= 40) return SCORE_LEVELS.FAIR;
  if (score >= 20) return SCORE_LEVELS.MODERATE;
  return SCORE_LEVELS.IMPROVE;
};

export const CATEGORIES = [
  {
    id: 'nutrition',
    name: 'โภชนาการและการฟื้นฟู',
    shortName: 'โภชนาการ/ฟื้นฟู',
    icon: nutritionIcon,
  },
  {
    id: 'metabolism',
    name: 'ระบบเผาผลาญ',
    shortName: 'ระบบเผาผลาญ',
    icon: metabolismIcon,
  },
  {
    id: 'exercise',
    name: 'ออกกำลังกาย',
    shortName: 'ออกกำลังกาย',
    icon: exerciseIcon,
  },
  {
    id: 'stress',
    name: 'ความเครียด',
    shortName: 'ความเครียด',
    icon: stressIcon,
  },
  {
    id: 'gut',
    name: 'สมดุลลำไส้',
    shortName: 'สมดุลลำไส้',
    icon: gutBalanceIcon,
  },
  {
    id: 'skin',
    name: 'สุขภาพผิว',
    shortName: 'สุขภาพผิว',
    icon: skinHealthIcon,
  },
];

export const MOCK_SCORES = {
  nutrition: 72,
  metabolism: 37,
  exercise: 19,
  stress: null,
  gut: 55,
  skin: 72,
};
